// AUTO-GENERATED by gatsby-node.js — do not edit
// School: sfs
export const firebaseConfig = {
  "apiKey": "AIzaSyDKQ0V29si0Rd8SkWGggaxpLrcBhGmeXjc",
  "authDomain": "espanol-con-vic.firebaseapp.com",
  "projectId": "espanol-con-vic",
  "storageBucket": "espanol-con-vic.firebasestorage.app",
  "messagingSenderId": "861885313637",
  "appId": "1:861885313637:web:f2ee376c78192f0cbe8c8c"
};
export const schoolId = "sfs";
